'use client';

import React from 'react';
import BestieAvatar from '@components/templates/bestie/BestieAvatar';

interface PulsatingBestieAvatarProps {
  isConnected: boolean;
}

/**
 * PulsatingBestieAvatar
 *
 * Displays the Bestie AI avatar with a pulsating animated effect.
 * When the `isConnected` prop is true, the avatar features an animated pulse background,
 * indicating that an interview is actively in progress.
 *
 * Props:
 *  - isConnected (boolean): Toggle pulsing animation to represent active session.
 *
 */
export const PulsatingBestieAvatar: React.FC<PulsatingBestieAvatarProps> = ({
  isConnected,
}) => (
  <div className="flex flex-col items-center space-y-6">
    <div className="relative flex size-48 items-center justify-center">
      {/* Pulsating background - only when connected */}
      {isConnected && (
        <div className="absolute inline-flex size-52 animate-size-pulse rounded-full bg-secondary/15" />
      )}
      <BestieAvatar className="size-48 border-2 border-secondary" />
    </div>
  </div>
);

